import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV } from "@/constants/testIds";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/", label: "Home", testid: NAV.linkHome },
  { to: "/#omics-station", label: "Omics Station" },
  { to: "/#sqit-saas", label: "SQIT.ai SaaS Model" },
  { to: "/#sqit-ai", label: "SQIT.ai™" },
  // { to: "/modules", label: "Modules", testid: NAV.linkModules },
  { to: "/contact", label: "Contact Us", testid: NAV.linkContact },
];

export default function PublicNavbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-100 shadow-sm">
      <div className="sqit-container flex h-20 items-center justify-between">
        <div data-testid={NAV.logo} className="flex items-center gap-2">
          <Logo brand="bionivid" />
        </div>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => {
            const className = `text-sm font-medium transition-colors hover:text-[#006B3C] ${pathname === l.to ? "text-[#006B3C]" : "text-gray-600"
              }`;

            return l.to.includes("#") ? (
              <HashLink
                key={l.to}
                smooth
                to={l.to}
                className={className}
              >
                {l.label}
              </HashLink>
            ) : (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testid}
                className={className}
              >
                {l.label}
              </Link>
            );
          })}
        </nav>
        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E5E7EB] bg-white">
          <div className="sqit-container py-4 flex flex-col gap-1">
            {LINKS.map((l) => (
              <Link
                key={l.to} to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`${l.testid}-mobile`}
                className="py-2 text-sm text-gray-700 hover:text-[#09582D]"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
